<template>
  <router-view />
</template>

<script>
export default {
  name: 'GroundOpsIndex'
}
</script>
